import { render } from "./kycSuccess.vue?vue&type=template&id=28329ece&lang=true"
import script from "./kycSuccess.vue?vue&type=script&lang=js"
export * from "./kycSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__